import BaseApiController from 'controller/baseresourcecontroller';

export default class ImportController extends BaseApiController {
  constructor() {
    super('mvc/import');
  }

  async GetDestinations (filter) {
    return super.Post('GetDestinations', { filter: filter });
  }
  
  async GetAdvancedMode (data) {
    return super.Post('GetAdvancedMode', data);
  }
  async SetAdvancedMode (data) {
    return super.Post('SetAdvancedMode', data);
  }
  async GetCode (data) {
    return super.Post('GetCode', data);
  }
  async GetItem (autoid) {
    return super.Post(`GetItem?autoid=${autoid}`);
  }
  async Cancel (autoid) {
    return super.Post(`Cancel?autoid=${autoid}`);
  }
}
